<div class="table-container">

  <mat-table #table [dataSource]="loading ? [] : dataSource" matSort>

    @for (column of columnNames; track column) {
    <ng-container matColumnDef="{{ column.id }}">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ column.value }}</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element[column.id] }}</mat-cell>
    </ng-container>
    }

    <ng-container matColumnDef="userGuide">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element">@if (element.active) {
        <button class="table-button-primary" (click)="downloadUserGuide(element.code)"><span>Download user
            guide</span></button>
        }</mat-cell>
    </ng-container>

    <ng-container matColumnDef="doTraining">
      <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *matCellDef="let element">@if (element.active) {
        <button (click)="doTraining(element.hcontent_id, element.code)"
          [ngClass]="{'table-button' : !element.complete, 'table-complete' : element.complete}">
          <span>{{element.complete ? 'Completed' : element.step == null ? 'Start' : 'Resume'}} training</span></button>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="preview">
      <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *matCellDef="let element">@if (element.active) {
        <a (click)="previewTraining(element.hcontent_id, element.code)" class="table-link"><span>Preview
            Training</span></a>
        }</mat-cell>
    </ng-container>

    <ng-container matColumnDef="previewLibrary">
      <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *matCellDef="let element">@if (element.active) {
        <a (click)="previewLibrary(element.code)" class="table-link">Content Library</a>
        }</mat-cell>
    </ng-container>

    <ng-container matColumnDef="copySmartURL">
      <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *matCellDef="let element">@if (element.active) {
        <a (click)="copySmartURL(element.code)" class="table-link">Copy smart URL</a>
        }</mat-cell>
    </ng-container>



    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  @if (loading) {
  <div class="skeleton-container">
    @for (row of skeletonRows; track $index) {
    <div class="skeleton-row-flex">
      @for (weight of row; track $index) {
      <div class="skeleton-bar" [style.flex-grow]="weight"></div>
      }
    </div>
    }
  </div>
  }

  @for (notification of notifications; track notification.id) {
    @if (showNotification(notification.id)) {
    <div class="tip">
      <div style="position: absolute; right: 10px; bottom: 5px">
        <a (click)="hideNotification(notification.id)"> Mark as read</a>
      </div>
      <p [innerHTML]="notification.notification"></p>
    </div>
    }
  }

  @if (showTip) {
  <div class="tip">
    <div style="position:absolute; right:10px; bottom: 5px;">
      <a (click)="hideTip()"> Thanks, I got this!</a>
    </div>
    <p>Please note: when previewing training, your progress into the training is not recorded. You will not be able to
      resume the training from where you left off, nor will it be recorded as part of the completion report.</p>
  </div>
  }

</div>
